import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
const Index = lazy(() => import("./pages/Index"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Auth = lazy(() => import("./pages/Auth"));
const Admin = lazy(() => import("./pages/Admin"));
const AdminButtons = lazy(() => import("./pages/AdminButtons"));
const AdminReviews = lazy(() => import("./pages/AdminReviews"));
const AdminGenerations = lazy(() => import("./pages/AdminGenerations"));
const AdminCredits = lazy(() => import("./pages/AdminCredits"));
const AdminUsers = lazy(() => import("./pages/AdminUsers"));
const AdminModels = lazy(() => import("./pages/AdminModels"));
const AdminStoryboards = lazy(() => import("./pages/AdminStoryboards"));
const AdminStoryboardEdit = lazy(() => import("./pages/AdminStoryboardEdit"));
const AdminApiKeys = lazy(() => import("./pages/AdminApiKeys"));
const StoryBoard = lazy(() => import("./pages/StoryBoard"));
const Perspective = lazy(() => import("./pages/Perspective"));
const ColorGrading = lazy(() => import("./pages/ColorGrading"));
const NotFound = lazy(() => import("./pages/NotFound"));
const DemoOne = lazy(() => import("./pages/DemoOne"));
const HelixDemo = lazy(() => import("./pages/HelixDemo"));
const AnimatedHeroDemo = lazy(() => import("./pages/AnimatedHeroDemo"));
import { PublicOnly, RequireAuth } from "./pages/RequireAuth";
import Landing from "./pages/Landing";
import AppLayout from "@/components/AppLayout";
import Account from "./pages/Account";
import Legal from "./pages/Legal";
import CookiesPage from "./pages/Cookies";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
        <Routes>
          {/* Public landing page as root (under layout) */}
          <Route element={<AppLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route element={<PublicOnly />}>
              <Route path="/auth" element={<Auth />} />
            </Route>
            <Route element={<RequireAuth />}>
              <Route path="/editor" element={<Index />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/storyboard" element={<StoryBoard />} />
              <Route path="/perspective" element={<Perspective />} />
              <Route path="/colorgrading" element={<ColorGrading />} />
              <Route path="/demo" element={<DemoOne />} />
              <Route path="/admin" element={<Admin />}>
                <Route index element={<AdminButtons />} />
                <Route path="buttons" element={<AdminButtons />} />
                <Route path="models" element={<AdminModels />} />
                <Route path="reviews" element={<AdminReviews />} />
                <Route path="generations" element={<AdminGenerations />} />
                <Route path="credits" element={<AdminCredits />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="storyboards" element={<AdminStoryboards />} />
                <Route path="storyboard-edit" element={<AdminStoryboardEdit />} />
                <Route path="api-keys" element={<AdminApiKeys />} />
              </Route>
              {/* /billing removed; billing is handled inside Account */}
              <Route path="/account" element={<Account />} />
            </Route>
            <Route path="/animated-hero" element={<AnimatedHeroDemo />} />
            <Route path="/helix" element={<HelixDemo />} />
            {/* Catch all */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
